<div class="h-100 d-flex justify-content-between align-items-center">
  <div class="supplier-button text-primary d-flex justify-content-center align-items-center cp" (click)="onClick('addSupplier')">
    <span>Add Supplier</span>
  </div>
  @if (currentUser.role === Role.ADMIN || !currentRow.visibleAll) {
    <i class="cp icon-edit" tooltip="Edit session" (click)="onClick('edit')"></i>
  }

  @if (canShowActionDump()) {
    <div class="cp" tooltip="Download TCP dump" (click)="onClick('dump')">
      <i class="icon-cloud-download tcp-dump-icon"></i>
    </div>
  }
  @if (currentUser.role === Role.ADMIN || !currentRow.visibleAll) {
    <i class="cp far fa-trash-alt" tooltip="Delete session" (click)="onClick('delete')"></i>
  }
</div>
